import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import { Field, SelectInput } from '@hb/coffee';
import DictApi from '@/api/dict';
import { OptionItem } from '@/model/OptionItem';
import { SupplementInfoField } from '@/components/supplement-info-fields/types';
import { isEmptyFieldValue } from '../../utils';

@Component({ name: 'LiveStatus' })
export default class LiveStatus extends Vue implements SupplementInfoField {
  @Prop()
  private value!: undefined | number;

  private liveStatus: undefined | number | null = null;

  private options: OptionItem[] = [];

  private errorMsg = '';

  private async created() {
    if (this.value) {
      this.liveStatus = this.value;
    }

    this.options = await DictApi.getLiveStatus();
  }

  @Watch('value')
  private onValueChange(val: undefined | number) {
    this.liveStatus = val;
  }

  public onValidator(): boolean {
    if (isEmptyFieldValue(this.liveStatus)) {
      this.errorMsg = '请选择居住状态';
      return false;
    }

    this.errorMsg = '';
    return true;
  }

  private onChangeLiveStatus(val: number | undefined | null) {
    this.errorMsg = '';
    this.$emit('change', val);
  }

  private render() {
    return (
      <Field
        label="居住状态"
        errorMessage={this.errorMsg}
      >
        <SelectInput
          v-model={this.liveStatus}
          title="选择居住状态"
          placeholder="选择居住状态"
          options={this.options}
          optionFieldNames={{
            key: 'code',
            value: 'name',
          }}
          onChange={this.onChangeLiveStatus}
        />
      </Field>
    );
  }
}
